import appConfig from "../config/app.config";
import axios from "axios";
import { saveRemoteConfig } from "../libs/utils";

const fetchRemoteConfig = () => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: appConfig.apiUrl.remoteConfig,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        saveRemoteConfig(response.data);
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export { fetchRemoteConfig };
